import { useCallback, useEffect, useState } from "react";
import { calculateUCCFeeDetails } from "../../FeeCalculations";
import SB2RCMFee from "../fieldsets/SB2RCMFee";
import StandardSize from "../fieldsets/StandardSize";
import TotalPages from "../fieldsets/TotalPages";
import { FormProps } from "./FormProps";

import "./FormSeries.scss";

const FormSeriesG: React.FC<FormProps> = ({ setFeeDetails, resetDocumentSelection, documentType }) => {
    const [standardSizeSelection, setStandardSizeSelection] = useState("");
    const [sb2RcmFeeSelection, setSb2RcmFeeSelection] = useState("");
    const [totalPages, setTotalPages] = useState("");

    const clearForm = useCallback(() => {
        setStandardSizeSelection("");
        setSb2RcmFeeSelection("");
        setTotalPages("");
        setFeeDetails(null);
    }, [setFeeDetails]);

    useEffect(() => {
        clearForm();
    }, [documentType, clearForm]);

    const handleFormSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
        event.preventDefault();
        setFeeDetails(
            calculateUCCFeeDetails({
                baseFee: documentType.baseFee,
                standardSizeSelection,
                sb2RcmFeeSelection,
                totalPages,
            })
        );
    };

    return (
        <form onSubmit={(event) => handleFormSubmit(event)}>
            <StandardSize currentSelection={standardSizeSelection} setCurrentSelection={setStandardSizeSelection} />
            <SB2RCMFee currentSelection={sb2RcmFeeSelection} setCurrentSelection={setSb2RcmFeeSelection} />
            <TotalPages textInputValue={totalPages} setInputValue={setTotalPages} />
            <div>
                <button className="fee-calc-submit" type="submit">
                    Submit
                </button>
                <button className="fee-calc-submit" type="button" onClick={() => clearForm()}>
                    Reset
                </button>
                <button className="fee-calc-submit" type="button" onClick={resetDocumentSelection}>
                    Change Document Type
                </button>
            </div>
        </form>
    );
};

export default FormSeriesG;
